"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvedFeedstocksToastStatusSelector = exports.approvedFeedstocksLoadingSelector = exports.approvedFeedstocksSelector = void 0;
const approvedFeedstocksSelector = (state) => {
    return state.approvedFeedstocks.approvedFeedstocks;
};
exports.approvedFeedstocksSelector = approvedFeedstocksSelector;
const approvedFeedstocksLoadingSelector = (state) => {
    return state.approvedFeedstocks.areApprovedFeedstocksLoading;
};
exports.approvedFeedstocksLoadingSelector = approvedFeedstocksLoadingSelector;
const approvedFeedstocksToastStatusSelector = (state) => {
    return state.approvedFeedstocks.approvedFeedstocksToastStatus;
};
exports.approvedFeedstocksToastStatusSelector = approvedFeedstocksToastStatusSelector;
